import React, { useState, useEffect } from 'react';
import './FoundationCourseOverview.css';
import foundationCover from '../../assets/foundation/foundationschool.png';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';

const FoundationCourseOverview = () => {
    const navigate = useNavigate();
    const [enrollStatus, setEnrollStatus] = useState('idle'); // idle, loading, success, error
    const [activeIndex, setActiveIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', phone: '' });

    const API_BASE = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://ceindiazone2.in');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const classes = [
        { title: "Class 1", desc: "The New Creature", duration: "1 hr 30 min", lessons: 3, longDesc: "The term \"new creature\" is directly from scriptures (2 Cor 5:17), and describes the new man in Christ, that is, one who is born again. This new creature has a new life and therefore a new nature. This class will discuss some of the implications and realities of this." },
        { title: "Class 2", desc: "The Holy Spirit", duration: "2 hrs", lessons: 4, longDesc: "To provide a firm understanding into the absolute, essential, active and required Ministry of the Holy Spirit in the life of every Christian." },
        { title: "Class 3", desc: "Christian Doctrine", duration: "1 hr 45 min", lessons: 3, longDesc: "In this Class, we will cover the following:\n1. Supremacy of the Bible\n2. Living in Two Worlds\n3. What are Doctrines and why are they important?\n4. Key Christian Doctrines\n5. Christian Activism and Apologetics\n6. Loveworld Exceptionalism, Expansionism and Perfectionism" },
        { title: "Class 4", desc: "Evangelism and Soul Winning", duration: "2 hrs 15 min", lessons: 5, longDesc: "Evangelism refers to reaching someone else with the message that you have believed and which changed your life, with the intention that it will change their life also.\n\nThe Objective of this Class is to introduce the Foundation School Student to the necessity and benefits of the Cell Ministry and also make clear his/her responsibility to participate and contribute." },
        { title: "Class 5", desc: "Christian Character and Prosperity", duration: "2 hrs", lessons: 4, longDesc: "The new Creature has a new life, which makes it possible to develop a new character and lifestyle that is consistent with his calling in Christ. While your salvation is instantaneous, your growth is progressive, and is from glory to glory. Growth can be seen in the quality of your Character, which as a Christian is expected to be Christ like. This is not only possible, it is necessary. In this Class we will look at some fundamentals from the scriptures to set you on a course of irreversible and progressive growth!" },
        { title: "Class 6", desc: "The Local Assembly and Loveworld Inc. (Christ Embassy)", duration: "1 hr 45 min", lessons: 3, longDesc: "In this Class, we will discuss the necessity of belonging to a Local Assembly, why you must attend Services consistently and a review of our Ministry’s Vision, Mission and Statements of Faith." },
        { title: "Class 7", desc: "Introduction to Mobile Technology for Personal Growth, Evangelism and Church Growth", duration: "1 hr 30 min", lessons: 3, longDesc: "In Christ Embassy, we believe strongly that Technology is primarily for the propagation of the Gospel. Technology and all its best advantages are suited for the Work of the Ministry. Therefore in Christ Embassy, we are foremost users of existing technology and creators of new technology for the furtherance of the gospel." },
    ];

    const handleEnrollClick = () => {
        // Commented out for local testing without backend
        /*
        const token = localStorage.getItem("token");
        const isAuthenticated = !!token && token !== "undefined";

        if (!isAuthenticated) {
            window.location.href = "/signIn?redirect=/foundation-course";
            return;
        }
        */

        setShowModal(true);
    };

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleProceed = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.phone) {
            alert("Please fill in all required fields.");
            return;
        }

        setShowModal(false);
        setEnrollStatus('loading');

        try {
            const response = await fetch(`${API_BASE}/api/enrollment/request`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setEnrollStatus('success');
            } else {
                setEnrollStatus('error');
            }
        } catch (error) {
            console.error("Error submitting enrollment:", error);
            setEnrollStatus('error');
        }
    };

    return (
        <div className="course-overview-page">
            <Navbar />

            {/* Background Blobs */}
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>
            <div className="blob blob-3"></div>

            {/* Enrollment Confirmation Modal */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-card enrollment-form-modal">
                        <button className="modal-close-btn" onClick={() => setShowModal(false)}>✕</button>
                        <div className="modal-icon">📚</div>
                        <h2>Register for Foundation School</h2>
                        <p className="modal-subtitle">Fill in your details to begin your journey of faith.</p>
                        
                        <form className="enrollment-form" onSubmit={handleProceed}>
                            <div className="form-group">
                                <label>Full Name *</label>
                                <input 
                                    type="text" name="name" 
                                    placeholder="Enter your full name"
                                    value={formData.name} onChange={handleFormChange} required 
                                />
                            </div>
                            <div className="form-group">
                                <label>Email Address *</label>
                                <input 
                                    type="email" name="email" 
                                    placeholder="Enter your email"
                                    value={formData.email} onChange={handleFormChange} required 
                                />
                            </div>
                            <div className="form-group">
                                <label>Phone Number *</label>
                                <input 
                                    type="tel" name="phone" 
                                    placeholder="Enter your phone number"
                                    value={formData.phone} onChange={handleFormChange} required 
                                />
                            </div>
                            
                            <p className="form-disclaimer">
                                By clicking proceed, your details will be shared with the Christ Embassy Pune administration team.
                            </p>

                            <div className="modal-actions">
                                <button type="button" className="modal-btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                                <button type="submit" className="modal-btn-primary">Proceed</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Course Hero Section */}
            <header className="course-hero-section">
                <div className="course-hero-container">
                    <div className="course-hero-content">
                        <div className="breadcrumb">
                            <span onClick={() => navigate('/')}>Home</span> &gt; <span>Foundation School</span>
                        </div>
                        <h1 className="course-title">Foundation <span>School</span></h1>
                        <p className="course-subtitle">
                            Master the basic doctrines of Christ and lay a solid foundation for a fulfilling and effective life in ministry.
                        </p>

                        <div className="course-instructor">
                            Offered by <strong>Christ Embassy Pune</strong>
                        </div>

                        <div className="hero-action-area">
                            {enrollStatus === 'idle' && (
                                <button className="btn-primary" onClick={handleEnrollClick}>
                                    Join Foundation School
                                </button>
                            )}

                            {enrollStatus === 'loading' && (
                                <button className="enroll-btn loading-btn" disabled>
                                    <div className="spinner"></div> Submitting Request...
                                </button>
                            )}

                            {enrollStatus === 'success' && (
                                <div className="success-message">
                                    <div className="success-icon">✓</div>
                                    <p>Enrollment request submitted! Our ministry team will contact you shortly.</p>
                                </div>
                            )}

                            {enrollStatus === 'error' && (
                                <div className="error-message" style={{ color: '#ff4d4d', marginTop: '10px' }}>
                                    <p>Something went wrong. Please try again or contact us directly.</p>
                                    <button className="btn-secondary" onClick={() => setEnrollStatus('idle')}>Try Again</button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="course-hero-media">
                        <div className="course-video-preview" onClick={() => setShowVideo(true)}>
                            <img src={foundationCover} alt="Foundation School Preview" fetchpriority="high" decoding="sync" />
                            <div className="play-overlay">
                                <div className="play-button">▶</div>
                            </div>
                        </div>

                        {showVideo && (
                            <div className="video-modal-overlay" onClick={() => setShowVideo(false)}>
                                <div className="video-modal-inner" onClick={e => e.stopPropagation()}>
                                    <button className="video-modal-close" onClick={() => setShowVideo(false)}>✕</button>
                                    <iframe
                                        src="https://www.youtube.com/embed/DZFUCSBOssQ?autoplay=1"
                                        title="Foundation School"
                                        allow="autoplay; encrypted-media"
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* Main Content Area */}
            <main className="course-main-content">
                <section className="course-learn-section">
                    <h2>What You'll Learn</h2>
                    <ul className="learn-list">
                        <li><span className="check">✓</span> Build a strong foundation in Christian faith.</li>
                        <li><span className="check">✓</span> Understand the vision, mission, and structure of the ministry.</li>
                        <li><span className="check">✓</span> Discover your purpose and role in God's Kingdom.</li>
                        <li><span className="check">✓</span> Develop consistent Bible study and spiritual disciplines.</li>
                        <li><span className="check">✓</span> Grow through fellowship with believers and the Holy Spirit.</li>
                        <li><span className="check">✓</span> Serve effectively in the local church and beyond.</li>
                        <li><span className="check">✓</span> Prepare for greater responsibilities in ministry.</li>
                    </ul>
                </section>

                <section className="course-description-section" style={{ marginBottom: '60px' }}>
                    <h2>Description</h2>
                    <p>
                        The aim of the membership school is to educate Christians concerning
                        the basic doctrines of Christ and lay a good foundation, which can
                        be built upon to live an effective and fulfilling life.
                    </p>
                    <p>
                        Foundation school classes  have been designed to span across a period
                        of 6 weeks; this is to enable you to have a deep understanding of what's
                        been taught and also gives you more time to study. Study to show
                        thyself approved, a workman that needs not to be ashamed, rightly dividing the word of truth.
                    </p>
                </section>

                <section className="course-curriculum-section">
                    <h2>Program Structure</h2>
                    <p className="curriculum-meta">
                        {classes.length} Modules • Comprehensive Foundation Learning
                    </p>

                    <div className="curriculum-accordion">
                        {classes.map((cls, index) => (
                            <div className={`accordion-item ${activeIndex === index ? 'active' : ''}`} key={index}>
                                <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                                    <div className="accordion-title">
                                        <span className={`chevron ${activeIndex === index ? 'rotated' : ''}`}>▶</span>
                                        <strong>{cls.title}: {cls.desc}</strong>
                                    </div>
                                    <div className="accordion-dur">
                                        {cls.lessons} sessions • {cls.duration}
                                    </div>
                                </div>
                                <div className={`accordion-content ${activeIndex === index ? 'expanded' : ''}`}>
                                    <p style={{ whiteSpace: 'pre-line' }}>{cls.longDesc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>

        </div>
    );
};

export default FoundationCourseOverview;
